/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FormInput } from 'components/kendoInputComponent/kendoInput'
import _ from 'underscore'
import { withRouter } from 'react-router-dom'
import { KendoNotification } from '../../../components/kendoNotificationComponent/kendoNotification'
import urlConstant from '../../../constants/urlConstant'
import dataConstant from '../../../constants/dataConstants'
import CommonService from '../../../services/commonService'
import messageConstant from '../../../constants/messageConstant'
import '../../../config/authRedirect'
import $ from 'jquery'
import { withTranslation } from 'react-i18next'
import i18n from '../../../i18n'
import logo from '../../../../src/assets/images/logo-light.png'

const passwordRegex = dataConstant.PasswordValidation

let password = ''

export const passwordValidator = value => {
  let validationmessage = ''
  if (!value) {
    validationmessage = `${messageConstant.Required} new password`
  } else if (value.length > 20) {
    validationmessage = messageConstant.User.PasswordIsNotMoreThan20Char
  } else if (!passwordRegex.test(value)) {
    validationmessage = messageConstant.PasswordValidationMessage
  } else if (dataConstant.WhiteSpaceRegex.test(value)) {
    validationmessage = messageConstant.WhiteSpaceValidationMessage
  }
  password = value
  return validationmessage
}

export const oldPasswordValidator = value => {
  let validationmessage = ''
  if (!value) {
    validationmessage = `${messageConstant.Required} old password`
  }
  return validationmessage
}

export const confirmPasswordValidator = value =>
  value !== password ? messageConstant.User.PasswordDoseNotMatch : ''

@withRouter
@connect(({ user }) => ({ user }))
class Header extends React.Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
    this.state = {
      username: '',
      isDisplay: false,
      ChangePasswordDetails: {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: '',
        isNotification: true,
        apiResponse: {},
      },
    }
  }

  componentDidMount() {
    const toLogout = localStorage.getItem('logoutUser')
    if (toLogout) {
      this.signOut()
    }
  }

  logout = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  signOut = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/SIGNOUT',
    })
  }

  changePassword = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/CHANGEPASSWORD',
    })
  }

  OnSideMenubarClick = e => {
    e.preventDefault()
    $('.main-container').toggleClass('sidebar-closed')
    $('.header.navbar').toggleClass('expand-header')
    $('.main-container').toggleClass('sbar-open')
    $('.overlay').toggleClass('show')
    $('html,body').toggleClass('sidebar-noneoverflow')
  }

  handleCancel = () => {
    this.setState({
      isDisplay: false,
    })
  }

  handlePasswordSubmit = event => {
    const modelData = {
      OldPassword: event.OldPassword,
      NewPassword: event.NewPassword,
    }
    this.CommonService.httpPost(urlConstant.UserManagement.ChangePassword, modelData, true)
      .then(response => {
        this.setState({
          isNotification: true,
          apiResponse: response,
          isDisplay: false,
          changePasswordUserID: '',
        })
        setTimeout(() => {
          this.setState({
            isNotification: false,
            apiResponse: {},
          })
        }, dataConstant.ToastNotificationTimeOut)
      })
      .catch(err => {
        console.error(err)
      })
  }

  viewData = () => {
    this.setState({
      isDisplay: true,
    })
  }

  render() {
    const { username, isDisplay, ChangePasswordDetails, isNotification, apiResponse } = this.state
    const {
      location: { pathname },
      t,
      menuList,
    } = this.props

    let currentRouteDetails = _.find(menuList, function findMenu(obj) {
      return (
        obj.menuLink === `${pathname}` ||
        obj.menuLink === `/${pathname.split('/')[1]}` ||
        obj.subMenuLink === `/${pathname.split('/')[1]}`
      )
    })

    if (currentRouteDetails === dataConstant.Undefined) {
      const subMenuList = _.filter(menuList, menu => menu.subMenuLink !== null)
      const menuWithAllSubMenu = _.flatten(
        _.map(subMenuList, item => {
          const subMenuLinks = item.subMenuLink.split(',')
          return _.map(subMenuLinks, menu => {
            return {
              menuId: item.menuId,
              menuLink: item.menuLink,
              subMenuLink: menu,
              path: item.path,
            }
          })
        }),
      )

      currentRouteDetails = _.find(menuWithAllSubMenu, function findMenu(obj) {
        return (
          obj.menuLink === `${pathname}` ||
          obj.menuLink === `/${pathname.split('/')[1]}` ||
          obj.subMenuLink === `/${pathname.split('/')[1]}`
        )
      })
    }

    const currentRoute = currentRouteDetails ? i18n.t(currentRouteDetails.path) : ''
    return (
      <>
        <KendoNotification isNotification={isNotification} response={apiResponse} />
        <div className="header-container fixed-top">
          <header className="header navbar navbar-expand-sm">
            <ul className="navbar-item theme-brand flex-row  text-center">
              <li className="nav-item theme-logo">
                <a href="/dashboard">
                  {/*
                  <img
                    src={imagePath}
                    loding="lazy"
                    className="navbar-logo nav-link"
                    alt="logo"
                    onLoad={console.log('loded')}
                    onError={(e) => console.log(`error ${e.nativeEvent.error}`)}
                  />
                  */}
                  <img src={logo} alt="" />
                </a>
              </li>
            </ul>
            <ul className="navbar-item flex-row ml-auto align-items-center">
              <span className="cm-title">{this.props.user.name}</span>
              <li className="nav-item dropdown user-profile-dropdown">
                <a
                  href="#"
                  onClick={e => e.preventDefault()}
                  className="nav-link dropdown-toggle user"
                  id="userProfileDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-user"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <i className="fa fa-caret-down" aria-hidden="true" />
                </a>
                <div
                  className="dropdown-menu position-absolute dropdown-padding"
                  aria-labelledby="userProfileDropdown"
                >
                  <div className="">
                    {/* <div className="dropdown-item">
                      <a href="/comingsoon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-user"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                        {t('My Profile')}
                      </a>
                    </div> */}
                    <div className="dropdown-item">
                      <a onClick={this.changePassword} className="cursor-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-lock"
                        >
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                        {t('Change Password')}
                      </a>
                    </div>
                    <div className="dropdown-item">
                      <a className="cursor-pointer" onClick={this.signOut}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-log-out"
                        >
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                          <polyline points="16 17 21 12 16 7" />
                          <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        {t('Sign Out')}
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </header>
        </div>

        <div className="sub-header-container">
          <header className="header navbar navbar-expand-sm">
            <a
              // href="#"
              onClick={this.OnSideMenubarClick}
              className="sidebarCollapse"
              data-placement="bottom"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-menu"
              >
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </a>
            <ul className="navbar-nav flex-row">
              <li>
                <div className="page-header">
                  <div className="page-title">
                    <h3>{currentRoute}</h3>
                  </div>
                </div>
              </li>
            </ul>
          </header>
        </div>
        {isDisplay ? (
          <>
            <Dialog className="cm-dialog-w" title="Change Password" onClose={this.handleCancel}>
              <Form
                initialValues={ChangePasswordDetails}
                onSubmit={this.handlePasswordSubmit}
                className="form-group"
                render={() => (
                  <FormElement>
                    <fieldset className="form-group">
                      <div className="row mx-0">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div>
                            <Field
                              className="form-control"
                              name="OldPassword"
                              component={FormInput}
                              type="password"
                              label="Old Password"
                              requiredText="*"
                              validator={oldPasswordValidator}
                            />
                          </div>
                          <div>
                            <Field
                              className="form-control"
                              name="NewPassword"
                              component={FormInput}
                              type="password"
                              label="New Password"
                              requiredText="*"
                              validator={passwordValidator}
                            />
                          </div>
                          <div>
                            <Field
                              className="form-control"
                              name="confirmPassword"
                              component={FormInput}
                              type="password"
                              label="Confirm Password"
                              requiredText="*"
                              validator={confirmPasswordValidator}
                            />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <div className="k-form-buttons row mx-0">
                      <div className="col-12 text-right">
                        <button
                          type="button"
                          className="mr-2 cm-btn-primary"
                          onClick={this.handleCancel}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="mb-2 cm-btn-primary">
                          Change Password
                        </button>
                      </div>
                    </div>
                  </FormElement>
                )}
              />
            </Dialog>
          </>
        ) : null}
      </>
    )
  }
}

export default withTranslation()(Header)
